// Legacy entry kept only because a WordPress registry row points at this file.
export default function PowderParticleScreeningPage() {
  return null;
}